import { api } from '@setplex/tria-api'
import { combine, createEvent, createStore } from 'effector'
import { register } from '~/core/repository'
import { transitionStart } from '~/core/router/model'
import { model as sessionModel } from '~/entities/session'
import { $navigationRendering } from '~/processes/navigation'
import '~/shared/ui/translations/general-translations'

export const markNoContentPageActive = createEvent()

const $noContentPageActive = createStore(false)
  .on(markNoContentPageActive, () => true)
  .reset(transitionStart)

export const $visible = combine(
  api.session.signOutFx.pending,
  api.session.guestInFx.pending,
  sessionModel.$guestReloginPending,
  $navigationRendering,
  $noContentPageActive,
  (
    signOutPending,
    guestInPending,
    guestReloginPending,
    navigationRendering,
    noContentPageActive
  ) =>
    !signOutPending &&
    !guestInPending &&
    !guestReloginPending &&
    !navigationRendering &&
    noContentPageActive
)

register($visible, '$shared/ui/NoContentBlock/visible')
